var installedModules = {};
var moduleToHandlerMapping = {
	77485: {
		getter: function() { return __webpack_require__.e(892).then(function() { return function() { return __webpack_require__(892); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^2.7.16",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "vue",
	},
	85362: {
		getter: function() { return __webpack_require__.e(1242).then(function() { return function() { return __webpack_require__(1242); }; }); },
		shareInfo: {
			shareConfig: {
			  "fixedDependencies": false,
			  "requiredVersion": "^3.6.2",
			  "strictVersion": false,
			  "singleton": true,
			  "eager": false
			},
			scope: ["default"],
		},
		shareKey: "vuex",
	}
};
// no consumes in initial chunks
var chunkMapping = {
	"90049": [
		77485,
		85362
	]
};
__webpack_require__.f.consumes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping: moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}